@if (userScoring$ | async; as userScoring) {

<div class="row">
    <div class="col-sm-6">
        <div class="table-awards-wrapper">
            @if (userScoring.userCompletedItems.length > 0) {
            <table class="table table-awards">
                <thead>
                    <tr>
                        <th scope="col">Completed activities</th>
                        <th scope="col">Points</th>
                    </tr>
                </thead>
                <tbody>
                    @for (item of userScoring.userCompletedItems; track item.dataRecord) {
                    <tr>
                        <td [innerText]="item.friendlyName"></td>
                        <td [innerText]="item.points"></td>
                    </tr>
                    }
                </tbody>
            </table>
            } @else {
            <p class="mb-0">No completed activities yet.</p>
            } @if (userScoring.userPendingItems.length > 0) {
            <table class="table table-awards">
                <thead>
                    <tr>
                        <th scope="col">Other activities to complete</th>
                        <th scope="col">Points</th>
                    </tr>
                </thead>
                <tbody>
                    @for (item of userScoring.userPendingItems; track item.dataRecord) {
                    <tr>
                        <td [innerText]="item.friendlyName"></td>
                        <td [innerText]="item.defaultScore"></td>
                    </tr>
                    }
                </tbody>
            </table>
            } @else {
            <p class="mb-0">All activities completed!</p>
            }
        </div>
    </div>
    <div class="col-sm-6">
        <div class="award-level__container">
            @if (userScoring.userLevel) {
            <div class="award-level__image-wrapper">
                <img
                    [alt]="userScoring.userLevel.label"
                    [src]="userScoring.userLevel.data?.image_url"
                    class="img-fluid" />
            </div>
            }

            <h3 class="award-level__heading">Awards level</h3>
            <div class="score-summary">
                <div class="award-level__points">
                    <p>Total Points: <span [innerText]="userScoring.totalPoints"></span></p>
                </div>
                <ng-container
                    *ngTemplateOutlet="
              ctaButton;
              context: {
                  text: block.data.linkText,
                  link: block.data.link,
                  external: block.data.externalLink,
                  aria: block.data.linkAriaLabel,
              }
          "></ng-container>
            </div>
        </div>
    </div>
</div>

<!-- Reusable CTA button template -->
<ng-template #ctaButton let-text="text" let-link="link" let-external="external" let-aria="aria">
    @if (!external) {
    <!-- Not external so we're safe to use routerLink -->
    <a
        [innerText]="text"
        [routerLink]="link"
        [target]="external ? '_blank' : '_self'"
        [attr.aria-label]="aria ? aria : ''"
        class="btn btn-primary mb-0"></a>
    } @else {
    <!-- External so we're using href -->
    <a
        [innerText]="text"
        [href]="link"
        [target]="external ? '_blank' : '_self'"
        [attr.aria-label]="aria ? aria : ''"
        class="btn btn-primary mb-0"></a>
    }
</ng-template>
} @else {
<p>Loading...</p>
}
